var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dx-scroll-view',{staticClass:"with-footer single-card",attrs:{"height":"100%","width":"100%"}},[_c('div',{staticClass:"dx-card content"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }